import { PartialGrade } from 'app/library/partial-grade/models/partial-grade.model';

export class SetModulePartialGrades {
    static readonly type = '[ModulePartialGrades] SetModulePartialGrades';

    constructor(public payload: PartialGrade[]) {}
}

export class UnsetModulePartialGrades {
    static readonly type = '[ModulePartialGrades] UnsetModulePartialGrades';
}

export class FetchModulePartialGrades {
    static readonly type = '[ModulePartialGrades] FetchModulePartialGrades';

    constructor(public payload: string) {}
}

export class FetchModulePartialGradesSuccess {
    static readonly type = '[ModulePartialGrades] FetchModulePartialGradesSuccess';
}

export class FetchModulePartialGradesFailure {
    static readonly type = '[ModulePartialGrades] FetchModulePartialGradesFailure';
}

export class ToggleSelectedModulePartialGrade {
    static readonly type = '[ModulePartialGrades] ToggleSelectedModulePartialGrade';

    constructor(public payload: string) {}
}

export class SelectFilteredModulePartialGrades {
    static readonly type = '[ModulePartialGrades] SelectFilteredModulePartialGrades';
}

export class DeselectSelectedModulePartialGrades {
    static readonly type = '[ModulePartialGrades] DeselectSelectedModulePartialGrades';
}

export class SearchModulePartialGrades {
    static readonly type = '[ModulePartialGrades] SearchModulePartialGrades';

    constructor(public payload: string) {}
}
